<script setup lang="ts">
import { useTranslation } from 'i18next-vue';
import Button from 'primevue/button';

import { CheckAllIcon } from '@peanuds/ui';

interface Props {
  disabled: boolean;
}

defineProps<Props>();
defineEmits<{ markAllAsRead: [] }>();

const { t } = useTranslation();
</script>

<template>
  <div class="notifications-drawer-footer">
    <Button
      :label="t('nav.notifications_actions.mark_all_as_read')"
      severity="primary"
      rounded
      size="large"
      iconPos="right"
      :disabled="disabled"
      @click="$emit('markAllAsRead')"
    >
      <template #icon>
        <CheckAllIcon class="notifications-drawer-footer__icon" />
      </template>
    </Button>
  </div>
</template>

<style scoped lang="scss">
.notifications-drawer-footer {
  display: flex;
  justify-content: flex-start;
  padding: $static-space-4;
  background: var(--p-surface-0);

  :deep(.p-button) {
    font-size: $static-text-md;
  }
}

.notifications-drawer-footer__icon {
  width: $icon-sm;
  height: $icon-sm;
}
</style>
